/**
 * @file Vue mixin to make component send user presence data to back end (for notification)
 */

import { Component, namespace, State, Vue } from 'bits/vue'

const realtime = namespace('realtime')

@Component({})
export default class PresenceMixin extends Vue {
  intervalId
  @State((state): number => state.constants.presenceCallIntervalInSeconds) intervalInSeconds
  @realtime.Action absent
  @realtime.Action present

  listener(): void {
    if (document.visibilityState === 'visible') {
      this.present()
    } else {
      this.absent()
    }
  }

  mounted(): void {
    document.addEventListener('visibilitychange', this.listener)
    document.addEventListener('beforeunload', this.absent)
    this.listener()

    // The Presence key-value entry in MemStore has a TTL of intervalInSeconds.
    // Given that the event listener only calls updatePresence on visibility change,
    // if a user is on a wall for > intervalInSeconds (i.e. there is no visibility change),
    // the user will be marked as absent on the backend. This is why the following is required.
    this.intervalId = setInterval(this.listener, this.intervalInSeconds * 1000)
  }

  beforeDestroy(): void {
    clearInterval(this.intervalId)
    document.removeEventListener('visibilitychange', this.listener)
    this.absent()
  }
}
